export const ICON_SIZE_XXS = 12;
export const ICON_SIZE_XS = 14;
export const ICON_SIZE_S = 16;
export const ICON_SIZE = 18;
export const ICON_SIZE_L = 20;
export const ICON_SIZE_XL = 22;
export const ICON_SIZE_XXL = 24;
